import { render, staticRenderFns } from "./MenuMaintenance.vue?vue&type=template&id=66d96c06&scoped=true"
import script from "./MenuMaintenance.vue?vue&type=script&lang=js"
export * from "./MenuMaintenance.vue?vue&type=script&lang=js"
import style0 from "./MenuMaintenance.vue?vue&type=style&index=0&id=66d96c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d96c06",
  null
  
)

export default component.exports